import { Question } from "resources/question/view/types";
import React, { useState } from "react";
import { Box, Button, IconButton, Menu, MenuItem, Stack, Typography } from "@mui/material";
import {
  ArrayField,
  Datagrid,
  DateField,
  FunctionField,
  Link,
  TextField,
  useRecordContext
} from "react-admin";
import AddQuestionDocumentModal from "resources/question/view/components/modals/AddQuestionDocumentModal";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import DeleteEntityModal from "components/category/DeleteEntityModal";

interface AnswerFormDocumentsProps {
  question: Question;
}

interface AnswerFormDocumentMenuProps {
  question: any;
}

const AnswerFormDocumentsMenu = ({ question }: AnswerFormDocumentMenuProps) => {
  const record = useRecordContext<any>();

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [isEditModalOpen, setEditModalOpen] = useState(false);
  const [isDeleteModalOpen, setDeleteModalOpen] = useState(false);

  const handleMenuOpen = (event: React.MouseEvent<HTMLElement>) => setAnchorEl(event.currentTarget);
  const handleMenuClose = () => setAnchorEl(null);

  const handleEdit = () => {
    setEditModalOpen(true);
    handleMenuClose();
  };

  const handleDelete = () => {
    setDeleteModalOpen(true);
    handleMenuClose();
  };

  return (
    <Box>
      <IconButton onClick={handleMenuOpen}>
        <MoreVertIcon/>
      </IconButton>
      <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleMenuClose}>
        <MenuItem onClick={handleEdit}>Редактировать</MenuItem>
        <MenuItem onClick={handleDelete}>Удалить</MenuItem>
      </Menu>

      <AddQuestionDocumentModal
        isOpen={isEditModalOpen}
        onClose={() => setEditModalOpen(false)}
        question={question}
        document={record}
      />
      <DeleteEntityModal
        isOpen={isDeleteModalOpen}
        onClose={() => setDeleteModalOpen(false)}
        entity={{ id: record.id, title: record.title }}
        resource="question-document"
        entityText={{
          title: "Удаление документа вопроса",
          success: "Документ удален",
          error: "Ошибка удаление документа"
        }}
      />
    </Box>
  )
}

const AnswerFormDocuments = ({ question }: AnswerFormDocumentsProps) => {
  const [openAddQuestionDocumentModal, setOpenAddQuestionDocumentModal] = useState<boolean>(false);
  const handleOpenAddQuestionDocumentModal = () => setOpenAddQuestionDocumentModal(true);
  const handleCloseAddQuestionDocumentModal = () => setOpenAddQuestionDocumentModal(false);

  return (
    <Box>
      {question && (
        <Box sx={{ mt: 2 }}>
          <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ mb: 1 }}>
            <Typography variant="h6">Документы</Typography>

            <Button
              sx={{ width: 'fit-content' }}
              variant="contained"
              onClick={handleOpenAddQuestionDocumentModal}
            >
              Добавить
            </Button>
          </Stack>

          {(question as any)?.documents?.length > 0 ? (
            <ArrayField source="documents">
              <Datagrid bulkActionButtons={false} rowClick={false}>
                <TextField source="title" label="Название"/>
                <DateField source="publishedAt" label="Дата публикации"/>
                <TextField source="type.title" label="Тип"/>
                <TextField source="audiences" label="Аудитория"/>
                <FunctionField
                  label="Файл"
                  render={(record) => {
                    const url = record?.file?.url;
                    const name = record?.file?.name ?? 'Открыть файл';
                    return (
                      <Link to={url} target="_blank" rel="noopener noreferrer">
                        {name}
                      </Link>
                    );
                  }}
                />
                <FunctionField
                  label=""
                  sx={{ width: 56, textAlign: 'right' }}
                  render={() => (
                    <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                      <AnswerFormDocumentsMenu question={question}/>
                    </div>
                  )}
                />
              </Datagrid>
            </ArrayField>
          ) : (
            <Typography variant="body2" sx={{ opacity: 0.7 }}>
              документов нет
            </Typography>
          )}
        </Box>
      )}

      <AddQuestionDocumentModal
        isOpen={openAddQuestionDocumentModal}
        onClose={handleCloseAddQuestionDocumentModal}
        question={question}
      />
    </Box>
  )
}

export default AnswerFormDocuments
